import { ReportType } from 'types';
import { getFeatures } from 'selectors/serverSelectors';
import { store } from 'index';

const columnsByReportType = () => {
    return {
        AcrossLine: {
            Date: '927',
            CameraNm: '184',
            Interval: '6.1241.0.39',
            CountIn: '6.1241.0.40',
            CountOut: '6.1241.0.41',
            PeopleIn: 'Reports_AcrossLine_PeopleIn',
            PeopleOut: 'Reports_AcrossLine_PeopleOut',
            CarsIn: 'Reports_AcrossLine_CarsIn',
            CarsOut: 'Reports_AcrossLine_CarsOut',
            UnknownIn: 'Reports_AcrossLine_UnknownIn',
            UnknownOut: 'Reports_AcrossLine_UnknownOut',
        },
        Alarms: {
            Date: '927',
            Time: '405',
            CameraNm: '184',
            TriggerNm: '1385',
            Rule: '907',
            Algorithms: '2756',
            TimeAck: 'WC_REPORT_ALARM_ACKNOWLEDGEMENT_TIME',
            AcknowledgeTime: 'WC_REPORT_ALARM_LATENCY',
            ResetTime: getFeatures(store.getState()).advancedAlarmProcessing
                ? 'WC_REPORT_ALARM_RESET_TIME'
                : 'WC_REPORT_ALARM_ARCHIVE_TIME',
            TimeOfReset: 'WC_REPORT_ALARM_TIME_OF_RESET',
            User: '604',
            Alarm: 'Reports_AlarmReport_AlarmColumn',
            Comment: '95',
            Classification: '2048',
            Thumbnail: '6.1237.3111',
            RelDistance: 'AlarmLocationDistanceRel',
            AbsDistance: 'AlarmLocationDistanceAbs',
            Location: 'HARDWARE_SYSTEM_RANGE_LOCATION',
            Node: 'AlarmReportColumnNode',
            BulkProcessed: 'Reports_AlarmReport_BulkProcessedColumn',
        },
        AlarmStats: {
            Farm: '6.9622.4118',
            Date: '927',
            Interval: '6.1241.0.39',
            FalsePositive: '6.1237.3245',
            RealNonActionable: '6.1237.3246',
            RealActionable: '6.1232.38',
            Unmarked: '6.1237.3247',
            Total: '6.1237.3248',
        },
        FaceRec: {
            'Block Number': 'WC_REPORT_FACEREC_BLOCK_NUMBER',
            'Block Time Range': 'WC_REPORT_FACEREC_BLOCK_TIME_RANGE',
            Date: '927',
            'Source Time': 'WC_REPORT_FACEREC_ENTRANCE_TIME',
            'Source Camera': 'Reports_EntranceCamera',
            'Target Time': 'WC_REPORT_FACEREC_EXIT_TIME',
            'Target Camera': 'Reports_ExitCamera',
            Duration: 'LPR_DETAILED_LOG_DURATION',
            Score: 'MATCH_SCORE',
            'Source Thumbnail': 'WC_REPORT_FACEREC_ENTRANCE_THUMBNAIL',
            'Target Thumbnail': 'WC_REPORT_FACEREC_EXIT_THUMBNAIL',
        },
        HeatMap: {
            Date: '927',
            Time: '405',
            Zone: '6.1241.0.47',
            BelowThresholdCount: 'Report_HeatMap_BelowThresholdCount', // TODO: need to insert threshold
            AboveThresholdCount: 'Report_HeatMap_AboveThresholdCount',
            BelowThresholdTime: 'Report_HeatMap_BelowThresholdTime',
            AboveThresholdTime: 'Report_HeatMap_AboveThresholdTime',
        },
        InStock: {
            Date: '927',
            Interval: '6.1241.0.39',
            'Shelf.': '6.1241.0.53',
        },
        LPR: {
            Date: '927',
            Time: '405',
            CameraNm: '184',
            LicensePlate: 'LPR_LICENSE_PLATE',
            Region: 'LPR_DETAILED_LOG_PLATE_REGION',
            List: 'LPR_METADATA_ADD_PLATE_LIST',
            Description: '1003',
            Thumbnail: '6.1237.3111',
        },
        ObjectCounts: {
            Date: '927',
            Interval: '6.1241.0.39',
            CameraNm: '184',
            People: '6.1238.2',
            Cars: '6.1238.3',
            Unknown: '6.1238.4',
            Total: '6.1237.3248',
        },
        ObjectStats: {
            Date: '927',
            Interval: '6.1241.0.39',
            CameraNm: '184',
            Count: '6.1241.0.55',
            Dwell: '6.1241.0.56',
            Occupancy: '6.1241.0.57',
            Activity: '2923',
        },
        UserActivity: {
            ID: '6.2243.3',
            Date: '927',
            Time: '405',
            Description: '1003',
            Status: '195',
            User: '604',
        },
        OverheadPeopleCount: {
            Date: '927',
            CameraNm: '184',
            IntervalStart: 'Reports_TableColumns_IntervalStart',
            IntervalEnd: '6.1241.0.39',
            PeopleIn: 'Reports_AcrossLine_PeopleIn',
            PeopleOut: 'Reports_AcrossLine_PeopleOut',
        },
        RetentionTime: {
            ID: '6.2243.3',
            CameraNm: '184',
            CameraIp: '2619',
            Stream: '6.9622.3771',
            Server: 'Reports_RetentionTime_Column_RecordingServer',
            RecordingStartTime: 'Reports_RetentionTime_Column_RecordingStartTime',
            RecordingEndTime: 'Reports_RetentionTime_Column_RecordingEndTime',
            RetentionDuration: 'Reports_RetentionTime_Column_RetentionDuration',
            NormalLength: 'Reports_RetentionTime_Column_NormalLength',
            AbnormalLength: 'Reports_RetentionTime_Column_AbnormalLength',
            TotalLength: 'Reports_RetentionTime_Column_TotalLength',
            RecordingInterruptions: 'Reports_RetentionTime_Column_RecordingInterruptions',
            RecordingIntegrityRate: 'Reports_RetentionTime_Column_RecordingIntegrityRate',
        },
    };
};

export const getTextKeyForColumn = (reportType: ReportType, columnName: string): string => {
   if (!columnsByReportType()[reportType]) {
       throw new Error(`Report type ${reportType} is invalid`);
   }
   return columnsByReportType()[reportType][columnName]!;
};



// WEBPACK FOOTER //
// ./src/logic/reports/getTextKeyForColumn.ts